module.exports = __webpack_public_path__ + "static/media/certificate.1ad76ec3.PNG";